import { TableCacheKeyDto } from '@asset-metrix/portal-gateway-client-js';

import { prependRoleId } from './prependRoleId';
import { queryClient } from './queryClient';

export async function invalidateAllTableCaches(
  cacheKey: TableCacheKeyDto
): Promise<void> {
  await queryClient.invalidateQueries({
    queryKey: prependRoleId(['pageFilters']),
  });
  await queryClient.invalidateQueries({
    queryKey: prependRoleId(['customPageFilters']),
  });
  await invalidateTable(cacheKey);
}

export async function invalidateTable(
  cacheKey: TableCacheKeyDto,
  pageId?: string,
  widgetId?: string
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: prependRoleId([
        'tableFilters',
        ...(widgetId ? [widgetId] : []),
      ]),
    }),
    queryClient.invalidateQueries({
      queryKey: prependRoleId([
        'customQueryFilters',
        ...(widgetId ? [widgetId] : []),
      ]),
    }),
    queryClient.invalidateQueries({
      queryKey: prependRoleId([
        'datatables',
        cacheKey,
        ...(pageId ? [{ pageId }] : []),
        ...(widgetId ? [{ widgetId }] : []),
      ]),
    }),
    queryClient.invalidateQueries({
      queryKey: prependRoleId([
        'groupedDatatables',
        cacheKey,
        ...(pageId ? [{ pageId }] : []),
        ...(widgetId ? [{ widgetId }] : []),
      ]),
    }),
    queryClient.invalidateQueries({
      queryKey: prependRoleId([
        'footerDataKpi',
        ...(widgetId ? [widgetId] : []),
      ]),
    }),
    queryClient.invalidateQueries({
      queryKey: prependRoleId([
        'footerDataNonKpi',
        ...(widgetId ? [widgetId] : []),
      ]),
    }),
    queryClient.invalidateQueries({
      queryKey: prependRoleId(['footerDataForVega']),
    }),
  ]);
}
